module.exports = __webpack_public_path__ + "img/f13.50c7dee9.png";